import Activity, { type ActivityItem } from "@common/components/Activity/component";
import { UserProfilePicture } from "@common/components/ProfilePicture/component";
import { type Ai } from "@common/modules/ai/types";
import { getUserDisplayName } from "@common/modules/user/lib";
import React from "react";

type ChatHistoryProps = {
  chats: Ai.Chat.View.Chat[];
  onSelect: (chatId: string) => void;
};

export default (props: ChatHistoryProps) => {
  const activityItems = React.useMemo<ActivityItem[]>(
    () =>
      props.chats.map<ActivityItem>((x) => ({
        date: x.startDate,
        description: <div className="single-line-ellipsis">{x.shortDescription}</div>,
        icon: (
          <UserProfilePicture
            email={null}
            firstName={x.contactFirstName}
            lastName={x.contactLastName}
            profilePictureMediaSourceId={x.contactProfilePictureMediaSourceId}
            profilePictureMediaSourceKey={"AwsS3"}
            size={32}
          />
        ),
        title: getUserDisplayName({ firstName: x.contactFirstName, lastName: x.contactLastName }),
        id: x.chatId,
        onClick: () => props.onSelect(x.chatId)
      })),
    [props.chats]
  );

  return <Activity isNarrow className="chat_history" isDateHidden isNoTitle scrollTo="last" options={activityItems} />;
};
